module.exports = __webpack_public_path__ + "static/media/linkedIn-mobile.db5d2e45.svg";